import { arrayOf, normalize } from 'normalizr';
import { fromJS } from 'immutable';

import { entitySchema, ListTypes } from '../schemas';
import toRecords from '../normalizers';

// eslint-disable-next-line
export function entity(responseData) {
  // eslint-disable-next-line
  const listResponse = ListTypes.includes(responseData._type);
  const schema = listResponse ? { items: arrayOf(entitySchema) } : entitySchema;
  const data = normalize(responseData, schema);
  if (!listResponse) {

    if (responseData._type == 'InternalTimeReport') {
      data.result.pagination = responseData.pagination
    }

    return {
      ...toRecords(data),
      result: data.result,
    };
  }

  return {
    ...toRecords(data),
    result: {
      ...data.result,
      itemCount: data.result.itemCount,
      metaData: data.result.meta,
      itemsPerPage: data.result.itemsPerPage,
      pageCount: data.result.pageCount,
      items: fromJS(data.result.items),
      links: fromJS(data.result.links),
    },
  };
}
